import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { sectorsAtom } from '../../../../../../services/state/AppConfigStateJ';
import {
  dealLeadFilterState,
  dealTypeFilterStateDA,
  fromDateFilterStateDA,
  GroupByFilterState,
  sectorFilterState,
  toDateFilterStateDA,
} from '../../../../state/DealConversionFilterStateJ';

export const useFiltersParams = () => {
  const selectedToDate = useAtomValue(toDateFilterStateDA);
  const selectedFromDate = useAtomValue(fromDateFilterStateDA);
  const selectedDealType = useAtomValue(dealTypeFilterStateDA);
  const selectedGroupBy = useAtomValue(GroupByFilterState);
  const allSectors = useAtomValue(sectorsAtom);
  const allSectorsIds = useMemo(
    () => allSectors.map((sector) => sector.id).sort((a, b) => a - b),
    [allSectors]
  );

  const selectedSectors = useAtomValue(sectorFilterState);
  const selectedDealLead = useAtomValue(dealLeadFilterState) ?? -1;

  const orderedSelectedSectors: number[] = useMemo(
    () => selectedSectors.concat().sort((a, b) => a - b),
    [selectedSectors]
  );

  const sectors = !orderedSelectedSectors.length ? allSectorsIds : orderedSelectedSectors;

  const queryParams = {
    from: selectedFromDate.toISOString(),
    to: selectedToDate.toISOString(),
    dealType: selectedDealType,
    dealLead: selectedDealLead,
    sectors,
  };

  const queryParamsWithGroupBy = {
    ...queryParams,
    groupBy: selectedGroupBy,
  };

  return {
    queryParams,
    queryParamsWithGroupBy,
    selectedDealType,
  };
};
